import {Link, useParams, useNavigate} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


class PortalServiceReplays extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			replays: [],
		};
    this.getReplays = this.getReplays.bind(this);
		this.length = this.length.bind(this);
  };

  async componentDidMount() {
		

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		EventEmitter.emit('/client', y);

		this.getReplays();
	}

	componentWillUnmount() {
    
	}

	async getReplays() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/replays`, params);
		consoleLog(x.data);
		setTitle('Replays', x.data.servicename);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Replays', x.data.servicename);
			}

			let max = 0;
			for( let i in x.data.replays ) {
				let sum = 0;
				if( Object.keys(x.data.replays[i].viewers).reduce((sum,key)=>sum+parseFloat(x.data.replays[i].viewers[key].views||0),0) > 0 ) sum++;
				if( x.data.replays[i]?.playlist?.length > 0 ) sum++;
				if( x.data.replays[i]?.messages > 0 ) sum++;
				if( x.data.replays[i]?.followers?.length > 0 ) sum++;
				if( x.data.replays[i]?.published?.length > 0 ) sum++;
				x.data.replays[i].sum = sum;
				if( sum > max ) max = sum;
			}
			for( let i in x.data.replays ) x.data.replays[i].max = max;
			this.setState({replays: x.data.replays, publish: x.data.publish});
		}
	}

	length(length) {
		length /= 60;
		let hours = Math.floor(length / 60);
		let minutes = Math.floor(length % 60);
  	return hours===0?`${minutes} mins`:`${hours} hrs ${minutes} mins`;
	}

	setView(id) {
		const navigate = this.props.navigate;
		navigate(`/${this.state.service.id}/replay/${id}`);
	}

	render() {
		const user = this.context;

		const replays = this.state.replays.map((e,i) => {
			//console.log(Object.keys(e.viewers).reduce((sum,key)=>sum+parseFloat(e.viewers[key].views||0),0));
			return (
				<tr key={i} style={{cursor: 'pointer'}}>
					<td onClick={()=>this.setView(e.id)}>
						<img src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename.replace('mp4','png')}?d=${Math.floor(Date.now()/1000)}`} crossOrigin="use-credentials" width="124" alt="Replay Avatar" />
					</td>
					<td onClick={()=>this.setView(e.id)}>
						<div className="d-flex align-items-center">
							<div className="avatar avatar-sm me-2 avatar-rounded">
								<img src={e.avatar?`https://cloud.ultrastream.io/${e.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`}  alt="img" />
							</div>
							<div>
								<div className="lh-1">
									<span>{e.showname.length > 70 ? <>{e.showname.substring(0, 70)}...</>:<>{e.showname}</>}</span>
								</div>
								<div className="lh-1">
									{/*<span className="fs-11 text-muted">{moment(e.ctime*1000).format("DD/MM/YYYY H:mm:ss")}</span><br />*/}
									<div className="fs-12 text-danger pt-1">Expires {moment(e.ctime*1000+e.remove*1000).format("DD/MM/YYYY H:mm:ss")}</div>
								</div>
							</div>
						</div>
					</td>
					<td onClick={()=>this.setView(e.id)}>
						<div className="lh-1">
							{this.length(e.length)}<br />
							<div className="fs-12 text-muted pt-1">Running time</div>
						</div>
					</td>
					{Object.keys(e.viewers).reduce((sum,key)=>sum+parseFloat(e.viewers[key].views||0),0) > 0 &&
						<td>
							{Object.keys(e.viewers).length > 0 &&
								<div className="lh-1">
									{Object.keys(e.viewers).map((f,j) => {
										if( e.viewers[f].views > 0 )
											return (
												<React.Fragment key={j}>{f}: {e.viewers[f].views}&nbsp;</React.Fragment>
											)
										else
											return null;
									})}
									<br />
									<div className="fs-12 text-muted pt-1">Top Viewers</div>
								</div>
							}
						</td>
					}
					{e.playlist?.length > 0 &&
						<td onClick={()=>this.setView(e.id)}>
							{e.playlist &&
								<>Playlist: {e.playlist}</>
							}
						</td>
					}
					{e?.messages > 0 &&
						<td onClick={()=>this.setView(e.id)}>
							<div>Messages: {e.messages} </div>
						
							{/*Messages: ? Cheers ? Donations ?*/}
						</td>
					}
					{e.followers?.length > 0 &&
						<td>
							<div className="d-flex">
								{e.followers.length>0&&<>Followers: {e.followers.length}</>}
							</div>
							<div className="avatar-list-stacked">
								{e.followers.map((f,j) => {
									return (
										<OverlayTrigger
											key={j}
											placement="top"
											delay={{ show: 250, hide: 400 }}
											overlay={<Tooltip id="button-tooltip">
												<>{f.platform} - {f.username}</>
											</Tooltip>}
										>
											<a href={`${f.address}${f.username}`} target="_blank" rel="noreferrer">
												<span className="avatar avatar-md">
													<img src={f.avatar?f.avatar:`https://cloud.ultrastream.io/images/platforms/${f.platform.toLowerCase()}.png`} alt="avatar" />
												</span>
											</a>
										</OverlayTrigger>
									)
								})}
							</div>
						</td>
					}
					{e.published.length > 0 &&
						<td>
							{e.published.map((f,j) => {
								return (
									<a key={j} href={f.address} target="_blank" rel="noreferrer">
										<span className="badge bg-success me-1">
											{f.platform}
										</span>
									</a>
								)
							})}
						</td>
					}
					{e.sum < e.max &&
						<td colSpan={e.max - e.sum}></td>
					}
				</tr>
			)
		});

		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Replays</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Video Replays</span>
													<p className="fs-13 text-muted mb-0">View your recordings and stream analytics.</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
              </Row>
							<Row>
								<Col xs={12}>
									<table className="table text-nowrap table-hover">
										<tbody>
											{replays}
										</tbody>
									</table>
								</Col>
							</Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Replays = props => {
  const { service } = useParams();
	const navigate = useNavigate();
  return <PortalServiceReplays service={service} navigate={navigate} {...props} />
}
export default Replays;